import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import axios from "axios";
import sendServerLogging from "../../utils/sendServerLogging.js";
import userJSON from "../../utils/userJSON.js";


export default function LogoutButton({ setAuth }) {
  const navigate = useNavigate();

  const logout = (e) => {
    e.preventDefault();

    // get user_id from token
    const decoded_token = jwt_decode(localStorage.token);
    const user_id = decoded_token["user"]["id"];
    // update the logout
   
    // server logging
    sendServerLogging({
      body: {
        ...userJSON(localStorage.getItem("userName")),
        event: "LOGOUT",
        eventData: {}
      }})

    //console.log("User:%s logged out \n", user_id);

    localStorage.removeItem("token");
    localStorage.removeItem("date");

    setAuth(false);
    navigate("/login");
    toast.success("Logout successful");
  };

  return (
    <div
      className="flex flex-col w-full my-16 items-center"
      data-testid="logout-button"
    >
      <button
        type="button"
        className="w-[70%] laptop:text-xl text-center h-button-h desktop:text-2xl text-lg font-medium text-white hover:bg-accent1 bg-dark-purple rounded-lg "
        onClick={logout}
      >
        Logout
      </button>
    </div>
  );
}
